document.addEventListener("DOMContentLoaded", function () {
  // URL вашего опубликованного Google Apps Script
  const scriptURL = "https://script.google.com/macros/s/AKfycbypLlsP7rfH7JReIga45PW7Kk96NuVawIOGkELBiegGoV2us8BQmd08SXusrdMdFZyN/exec";
  
  // Проверка, голосовал ли уже пользователь
  const voted = localStorage.getItem("votedVideo");
  
  // Настраиваем видео и кнопки голосования
  document.querySelectorAll(".video-vote").forEach(container => {
    const videoId = container.dataset.id;
    const button = container.querySelector(".vote-button");
    const video = container.querySelector("video");
    
    // Создаем элемент для сообщений
    const message = document.createElement("p");
    message.className = "vote-message";
    container.appendChild(message);
    
    // Если пользователь уже голосовал, показываем соответствующий статус
    if (voted) {
      button.disabled = true;
      if (voted === videoId) {
        button.textContent = "You voted";
        message.textContent = "Your vote has been recorded.";
      }
    }
    
    // Обработчик нажатия на кнопку голосования
    button.addEventListener("click", () => {
      // Проверяем, не голосовал ли уже пользователь
      if (localStorage.getItem("votedVideo")) return;
      
      // Показываем сообщение о процессе
      message.textContent = "Sending your vote...";
      console.log("Sending vote for:", videoId);
      
      // // Открываем новое окно с URL скрипта и параметром videoId
      // const voteWindow = window.open(scriptURL + "?videoId=" + encodeURIComponent(videoId), 
      //                               "_blank", "width=400,height=300");
      
      // Сохраняем выбор пользователя и обновляем интерфейс
      localStorage.setItem("votedVideo", videoId);
      button.textContent = "You voted";
      button.disabled = true;
      document.querySelectorAll(".vote-button").forEach(b => b.disabled = true);
      message.textContent = "Thank you for your vote!";
      console.log("Done");

    });
    
    // Клик по видео для открытия в модальном окне
    video.addEventListener("click", () => {
      const modal = document.getElementById("video-modal");
      const modalVideo = document.getElementById("modal-video");
      modalVideo.src = video.src;
      modal.style.display = "flex";
    });
  });
  
  // Закрытие модального окна
  document.getElementById("modal-close").addEventListener("click", () => {
    const modal = document.getElementById("video-modal");
    const modalVideo = document.getElementById("modal-video");
    modal.style.display = "none";
    modalVideo.pause();
    modalVideo.src = "";
  });
  
  console.log("Voting system initialized!");
});